export default __webpack_public_path__ + "static/media/authoring_notification.aaf57736.svg";